module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Manifestation Details")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ffExportDetail.allModuleId ? _vm.ffExportDetail.allModuleId : '',
      "jobSeriesBanner": _vm.ffExportDetail.mainSalesSeries ? _vm.ffExportDetail.mainSalesSeries : '',
      "bannerClientName": _vm.ffExportDetail.clientName ? _vm.ffExportDetail.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExportDetail.allModuleId) ? _c('ContainerTable', {
    attrs: {
      "PMC_JOBID": _vm.ffExportDetail.allModuleId ? Number(_vm.ffExportDetail.allModuleId) : 0,
      "containers": [],
      "showContainerStatus": ''
    },
    on: {
      "status-change": _vm.activateUser
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ManifestationCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(_vm._s(" " + _vm.ManifestationCreated))]), _c('br')]) : _vm._e()]), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ManifestationUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.ManifestationUpdated))]), _c('br')]) : _vm._e()]), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentTypeList,
      "option-value": "TypeVal",
      "option-text": "TypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": function($event) {
        _vm.getAgentConsigneeList(_vm.AddManifestationDetail.type_of_agent)
      }
    },
    model: {
      value: (_vm.AddManifestationDetail.type_of_agent),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "type_of_agent", $$v)
      },
      expression: "AddManifestationDetail.type_of_agent"
    }
  }), _vm._v(" "), (!_vm.AddManifestationDetail.type_of_agent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.type_of_agent))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.AddManifestationDetail.type_of_agent) + "\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAllAgentColoaderList.length > 0 ?
        _vm.getAllAgentColoaderList :
        _vm.AddManifestationDetail.type_of_agent == 'Agent' ?
        _vm.$store.getters['common/getAllAgentColoaderList'] :
        _vm.$store.getters['common/getAllConsigneeList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": _vm.AddManifestationDetail.type_of_agent == 'Consignee' ?
        'Select Consignee' :
        'Select Agent/Coloader'
    },
    on: {
      "input": _vm.getConsigneeAgentDetails
    },
    model: {
      value: (_vm.AddManifestationDetail.AgentColoader),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "AgentColoader", $$v)
      },
      expression: "AddManifestationDetail.AgentColoader"
    }
  }), _vm._v(" "), (_vm.errorManifest.AgentColoader) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.AgentColoader +
    " " +
    _vm.AddManifestationDetail.type_of_agent))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.AddManifestationDetail.agent_coloder_txt || _vm.AddManifestationDetail.consignee_name) ? _c('b-card', {
    staticClass: "mt-2"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container Count")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount (Accept Only Numbers)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Final AMT")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Action\n                      "), _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.addInvArry
    }
  }, [_vm._v("\n                        Add\n                        "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _vm._l((_vm.lineADDManifestationModalArray), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.manifestationId != '' ? true : false,
        "list": _vm.TypeList,
        "option-value": "typeVal",
        "option-text": "typeText",
        "placeholder": "Select Type"
      },
      model: {
        value: (itm.addManifestation_type),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_type", $$v)
        },
        expression: "itm.addManifestation_type"
      }
    }), _vm._v(" "), (itm.addManifestation_type_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_type_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.manifestationId != '' ? true : false,
        "list": _vm.ParticularList,
        "option-value": "partVal",
        "option-text": "partText",
        "placeholder": "Select Particular"
      },
      model: {
        value: (itm.addManifestation_ledgerId),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_ledgerId", $$v)
        },
        expression: "itm.addManifestation_ledgerId"
      }
    }), _vm._v(" "), (itm.addManifestation_ledgerId_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_ledgerId_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "container_count",
        "name": "container_count",
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.updateAmount(itm)
        },
        "change": function($event) {
          _vm.updateAmount(itm)
        },
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (itm.container_count),
        callback: function($$v) {
          _vm.$set(itm, "container_count", $$v)
        },
        expression: "itm.container_count"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "disabled": itm.manifestationId != '' || itm.addManifestation_type == '' ?
          true :
          false,
        "formatter": _vm.capitalizeAll,
        "id": "amount",
        "name": "amount",
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.CheckValueNumbers($event)
        },
        "change": function($event) {
          _vm.CheckValueNumbers($event)
        },
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (itm.addManifestation_amount),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_amount", $$v)
        },
        expression: "itm.addManifestation_amount"
      }
    }), _vm._v(" "), (itm.addManifestation_amount_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_amount_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.manifestationId != '' ? true : false,
        "list": _vm.$store.getters['common/getAllCurrencyList'],
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (itm.addManifestation_currency),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_currency", $$v)
        },
        expression: "itm.addManifestation_currency"
      }
    }), _vm._v(" "), (itm.addManifestation_currency_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_currency_err))]) : _vm._e()], 1), _vm._v(" "), (itm.manifestationId != '') ? _c('td', [_vm._v(_vm._s(itm.final_amt || itm.container_count * itm.addManifestation_amount))]) : _vm._e(), _vm._v(" "), (itm.manifestationId == '') ? _c('td', [_vm._v(_vm._s(itm.final_amt || _vm.getSelectedContList.length * itm.addManifestation_amount))]) : _vm._e(), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "disabled": itm.manifestationId != '' ? true : false,
        "formatter": _vm.capitalizeAll,
        "id": "remark",
        "name": "remark"
      },
      model: {
        value: (itm.addManifestation_remark),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_remark", $$v)
        },
        expression: "itm.addManifestation_remark"
      }
    }), _vm._v(" "), (itm.addManifestation_remark_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_remark_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "disabled": itm.manifestationId != '' ? true : false,
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                        Remove\n                        "), _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Debit Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotDebit))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Credit Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotCredit))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Net Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotAMT))])])])], 2)])]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "5"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "2"
    }
  }, [(_vm.lineADDManifestationModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addAddManifestationDetail
    }
  }, [_vm._v("Save & Submit")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99a0707c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/ffCommonManifestation.vue
// module id = 2808
// module chunks = 0